import { MusicGenreDto } from '@/core/api/dtos/response/musicGenre/musicGenre'
import { MusicGenre } from '@/core/api/entities/musicGenre/musicGenre'

export class MusicGenreMapper {
	public static toEntity(dto: MusicGenreDto): MusicGenre {
		return new MusicGenre({
			id: dto.id,
			name: dto.name,
			key: dto.key,
		})
	}

	public static toDTO(entity: MusicGenre): MusicGenreDto {
		return {
			id: entity.id,
			name: entity.name,
			key: entity.key,
		}
	}

	public static toEntities(dtos: MusicGenreDto[]): MusicGenre[] {
		return dtos.map(this.toEntity)
	}
}
